import { SignalTypeMeta } from "@megaron/resource";

import { type SyncChannelDoc } from "./syncChannelDoc";

type DiffSyncSignalDocType = SyncChannelDoc["docType"];

export const diffSyncSignalTypes = {
  syncChannelChanges: {
    subjectDocType: "sync-channel",
    level: "warning",
    app: "crm",
    actionLabel: "Zmiany do synchronizacji",
  },
  syncChannelError: {
    subjectDocType: "sync-channel",
    level: "error",
    app: "crm",
    actionLabel: "Błąd synchronizacji",
  },
} as const satisfies Record<string, SignalTypeMeta<DiffSyncSignalDocType>>;
